import { render } from "./StorysInsta.vue?vue&type=template&id=962042f8"
import script from "./StorysInsta.vue?vue&type=script&lang=js"
export * from "./StorysInsta.vue?vue&type=script&lang=js"

import "./StorysInsta.vue?vue&type=style&index=0&id=962042f8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__